import { Text } from '@components';
import { Box, Button, styled } from '@mui/material';

export const Subtitle = styled(Text)(({ theme }) => ({
  color: theme.palette.grey.A100,
}));

export const ResendEmailBox = styled(Box)(({ theme }) => ({
  marginTop: `${parseInt(theme.spacing(16))}px`,
  marginBottom: `${parseInt(theme.spacing(16))}px`,
}));

export const ResendText = styled(Text)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const ResendButton = styled(Button)(({ theme }) => ({
  textTransform: 'capitalize',
  padding: 0,
  marginBottom: 3,
}));
